import { gsap } from "gsap";
import { TextPlugin } from "gsap/TextPlugin";

gsap.registerPlugin(TextPlugin);

const $body = $('body'),
    $topBar = $('.top-bar'),
    $overlay = $('.menu-overlay'),
    $overlayBackground = $('.menu-overlay__background'),
    $menu = $('.menu-overlay__nav .menu'),
    $fadeItems = $('.menu-overlay__nav .menu > .menu-item, .menu-overlay__title'),
    $menuItemLinks = $('.menu-overlay__nav .menu > .menu-item > a'),
    $titles = $('.menu-overlay__title-text'),
    $subtitles = $('.menu-overlay__nav .menu-item__dropdown .column__title');

// prepare elements for animation
gsap.set($fadeItems, { opacity: 0 });
gsap.set($menuItemLinks, { x: -10 });

$titles.each(function () {
    $(this).attr('data-original-text', $(this).text()).html('<span class="cursor"></span>');
});
$subtitles.each(function () {
    $(this).attr('data-original-text', $(this).text()).html('<span class="cursor"></span>');
});

$.fn.showMenu = function(e) {
    $overlay.show();

    if ($overlay.hasClass('menu-overlay--sub-menu-visible')) {
        // skip animations
        gsap.set($fadeItems, { opacity: 1 });
        gsap.set($titles, {
            text: (index, target) => {
                return target.getAttribute('data-original-text');
            }
        });
        gsap.set($menuItemLinks, { x: 0 });
    } else {
        gsap.to($fadeItems, {
            opacity: 1,
            duration: 0.15,
            stagger: .05,
            ease: 'power1.out',
            delay: 0.2
        });

        gsap.to($titles, {
            text: (index, target) => {
                return target.getAttribute('data-original-text');
            },
            duration: .5,
            stagger: .5,
            ease: 'none',
            delay: 0.25
        });

        gsap.to($menuItemLinks, {
            x: 0,
            duration: 0.15,
            stagger: .05,
            ease: 'power1.out',
            delay: 0.2
        });
    }

    gsap.to($overlayBackground, {
        opacity: 1,
        backdropFilter: 'blur(30px)',
        duration: 0.3,
        ease: 'power1.out'
    });
}

$.fn.hideMenu = function(e) {
    gsap.to($fadeItems, {
        opacity: 0,
        duration: 0.15,
        ease: 'power1.out',
        onComplete: () => {
            gsap.set($menuItemLinks, { x: -10 });
        }
    });

    gsap.to($overlayBackground, {
        opacity: 0,
        backdropFilter: 'blur(0)',
        duration: 0.3,
        ease: 'power1.out',
        onComplete: () => {
            $overlay.hide();
            //$menu.removeClass('menu--sub-menu-visible');
            //$menu.find('[data-state="toggled"]').attr('data-state', '');
            $('.menu-overlay__title-text').html('<span class="cursor"></span>');
        }
    });
}

// mobile menu toggle
$('[data-toggle="menu"]').on('click', function (e) {
    e.preventDefault();

    const $toggle = $(this);

    // disable button during animations
    $toggle.css('pointer-events', 'none');
    setTimeout(function () {
        $toggle.css('pointer-events', 'auto');
    }, 500);

    if ($body.hasClass('show-menu')) {
        $menu.hideMenu();
        $body.removeClass('show-menu');
    } else {
        let scrollOffset = $topBar.outerHeight() + $topBar.offset().top;

        if ($(window).scrollTop() < scrollOffset) {
            $('html, body').stop().animate({
                scrollTop: scrollOffset
            }, 150);
        }

        $body.addClass('show-menu');
        $menu.showMenu();
    }

    $toggle.blur();
});

// hide mobile menu on escape key press
$(document).keyup(function(e) {
    if (e.key === "Escape") {
        $menu.hideMenu();
        $body.removeClass('show-menu');
    }
});

// insert mobile sub-menu toggles
const dropDownIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97.51 103.52"><defs><style>.cls-1 { fill: #fb7d0f; }</style></defs><polygon class="cls-1" points="51.83 51.69 0 103.52 45.82 103.52 97.51 51.83 97.51 51.83 45.67 0 .14 0 51.83 51.69"/></svg>';

$('<button type="button" class="sub-menu-toggle" title="Sub-menu tonen/verbergen"><span class="sub-menu-toggle__icon">'+dropDownIcon+'</span></button>').insertBefore('.menu-overlay__nav .menu-item-has-children .menu-item__dropdown');

// toggle sub-menus
$body.on('click', '.menu-overlay .sub-menu-toggle', function () {
    const $toggle = $(this),
        $menu = $(this).closest('.menu'),
        $overlay = $(this).closest('.menu-overlay');

    if ($toggle.attr('data-state') === 'toggled') {
        $menu.removeClass('menu--sub-menu-visible');
        $overlay.removeClass('menu-overlay--sub-menu-visible');
        $toggle.attr('data-state', '');
    } else {
        $toggle.attr('data-state', 'toggled');
        $menu.addClass('menu--sub-menu-visible');
        $overlay.addClass('menu-overlay--sub-menu-visible');

        // hide elements in layer 1
        gsap.to($menu.closest('nav').siblings('h3, nav, .btns'), {
            opacity: 0,
            duration: .15
        });

        // animate titles
        gsap.to($toggle.siblings('.menu-item__dropdown').find('.column__title'), {
            text: (index, target) => {
                return target.getAttribute('data-original-text');
            },
            duration: .5,
            stagger: .5,
            ease: 'none',
            delay: 0.25
        });
    }

    $toggle.blur();
});

// back buttons in menu-item dropdowns
$('.menu-item__dropdown-back-button').on('click', function () {
    const $button = $(this),
        $menu = $(this).closest('.menu'),
        $overlay = $(this).closest('.menu-overlay');

    $button.closest('.menu-item__dropdown').siblings('.sub-menu-toggle').attr('data-state', '');

    setTimeout(function () {
        gsap.to($menu.closest('nav').siblings('h3, nav, .btns'), {
            opacity: 1,
            duration: .15
        });

        $menu.removeClass('menu--sub-menu-visible');
        $overlay.removeClass('menu-overlay--sub-menu-visible');
        $button.closest('.menu-item__dropdown').find('.column__title').html('<span class="cursor"></span>');
    }, 150);

    $button.blur();
});
